import { render } from "./BookParking.vue?vue&type=template&id=797d53bd"
import script from "./BookParking.vue?vue&type=script&lang=js"
export * from "./BookParking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__